
import React from "react";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AppLayout } from "./AppLayout";
import { useClientPreferenceOptions } from "@/hooks/useClientPreferenceOptions";

interface DashboardLayoutProps {
  children: React.ReactNode;
}

/** Warm preference-options cache once per authenticated dashboard session. */
const ClientPreferenceOptionsPrefetch = () => {
  useClientPreferenceOptions();
  return null;
};

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  return (
    <TooltipProvider>
      <ClientPreferenceOptionsPrefetch />
      <AppLayout>{children}</AppLayout>
    </TooltipProvider>
  );
};

export default DashboardLayout;
